export const LANGS = {
  NL: "nl",
  FR: "fr",
  DE: "de",
};
